/**
 * A global namespace for `loadstart` event.
 */
const loadstartEvent = 'loadstart';
export default loadstartEvent;
